import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: true,
  country: JSON.parse(localStorage.getItem('cofe-admin:country') || '{}'),
  data: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    update: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateCountry: (state, action) => {
      localStorage.setItem('cofe-admin:country', JSON.stringify(action.payload));
      return { ...state, country: action.payload };
    },
    reset: () => {
      return null;
    },
  },
});

export const selectUserState = state => state.user;
export const selectUser = createSelector(selectUserState, user => user?.data);
export const selectPermissions = createSelector(selectUser, user => user?.permissions);
export const selectCountry = createSelector(selectUserState, user => user?.country);
export const selectCountryId = createSelector(selectCountry, country => country?.id);
export default userSlice.reducer;
